import { render, staticRenderFns } from "./ProductRecordModal.vue?vue&type=template&id=18842f64"
import script from "./ProductRecordModal.vue?vue&type=script&lang=js"
export * from "./ProductRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18842f64')) {
      api.createRecord('18842f64', component.options)
    } else {
      api.reload('18842f64', component.options)
    }
    module.hot.accept("./ProductRecordModal.vue?vue&type=template&id=18842f64", function () {
      api.rerender('18842f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/ProductRecordModal.vue"
export default component.exports